// extracted by mini-css-extract-plugin
module.exports = {"m-call":"call_m-call__43mU5","m-call-content":"call_m-call-content__3SoRs"};